import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

interface CommandCenterData {
  criticos: number;
  escalados: number;
  slaVencido: number;
  aguardandoResponsavel: number;
  reabertos: number;
  automacoesExecutadasHoje: number;
  categorias: Array<{ categoria: string; total: number }>;
}

export function ChatCommandCenterDashboard() {
  const [data, setData] = useState<CommandCenterData | null>(null);

  useEffect(() => {
    api.get('/chat-interno/command-center').then((res) => setData(res.data));
  }, []);

  if (!data) return <div className="p-4 text-sm text-muted-foreground">Carregando central de comando...</div>;

  const cards = [
    ['Críticos', data.criticos],
    ['Escalados', data.escalados],
    ['SLA vencido', data.slaVencido],
    ['Sem responsável', data.aguardandoResponsavel],
    ['Reabertos', data.reabertos],
    ['Automações hoje', data.automacoesExecutadasHoje],
  ];

  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <div className="ac-chat-command-grid">
        {cards.map(([label, value]) => (
          <div key={String(label)} className="ac-chat-command-card">
            <p className="ac-chat-command-label">{label}</p>
            <h3 className="ac-chat-command-value">{value}</h3>
          </div>
        ))}
      </div>

      <div className="ac-chat-command-card">
        <p className="ac-chat-command-label">Categorias mais recorrentes</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          {data.categorias.map((item) => (
            <span key={item.categoria} className="ac-chat-category-pill">
              {item.categoria}: {item.total}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
